import React from 'react';

export function StripeProviderWrapper({ children, publishableKey }: { children: React.ReactNode, publishableKey: string }) {
  // En la vista web, Stripe nativo crashea Metro porque busca dependencias de iOS/Android.
  // Por lo tanto, simulamos el provider para que la web no falle.
  return <>{children}</>;
}
